// Class strings shared by every admin screen (pages/admin/*.tsx). Built on
// @ahcut/ui/recipes so data cells read the same as every other mono datum.

import { cx, dataClass } from "@ahcut/ui/recipes";

/** Side inset of a panel's header, body and footer (DataTable rows and edge cells match it). */
export const panelInsetClass = "px-5 sm:px-6";

/** Ids, timestamps, amounts, counts in a DataCell: mono, tabular, one line in
 *  table layout (DataCell lets the value break once the rows stack). */
export const dataCellClass = cx(dataClass, "whitespace-nowrap");

/** Ids, timestamps and amounts in a description list: mono at the term's 14px
 *  (a 36-character UUID then fits one value column at 1440). Ids go through
 *  BreakableText, so a narrower column wraps them at a hyphen; breaking inside a
 *  segment is only the fallback for one longer than the line. */
export const dataIdClass = cx(dataClass, "wrap-anywhere text-sm");

/** DescriptionList layout for detail panels: a 10rem term column from 640px,
 *  two term/value pairs per row from 1280px (DOM order stays pair by pair). */
export const factsGridClass = cx(
  "sm:grid-cols-[minmax(0,10rem)_minmax(0,1fr)]",
  "xl:grid-cols-[minmax(0,9rem)_minmax(0,1fr)_minmax(0,9rem)_minmax(0,1fr)] xl:gap-x-8",
);
